import { render, staticRenderFns } from "./VersionsTab.vue?vue&type=template&id=9d5ec060&"
import script from "./VersionsTab.vue?vue&type=script&lang=js&"
export * from "./VersionsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports